/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Risk-Model-UI
 * Date: 1/14/20
 * Copyright All Rights Reserved
 */
// @flow
import React from 'react';
import { Link, Redirect } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Label } from 'reactstrap';
import { Field } from 'redux-form';
import SubmitButton from 'components/support/buttons/SubmitButton';
import FieldFeedback from 'components/support/forms/FieldFeedback';
import RenderInput from 'components/support/forms/RenderInput';
import OrgSelectMenu from '../../support/OrgSelectMenu';
import { emptyOrMaxLength100, required, emptyOrEmail } from 'support/validators';


type Props = {
  error?: string,
  form: string,
  handleSubmit: Function,
  submitSucceeded: boolean,
  submitting: boolean,
}

const CreateUserForm = (props: Props) => {
  const {
    error, form, handleSubmit, submitting, submitSucceeded,
  } = props;
  const redirect = submitSucceeded ? <Redirect to="/admin/user" /> : null;
  const alert = error ? <div className="alert alert-danger">{error}</div> : null;
  return (
    <Form className="create-user-form" onSubmit={handleSubmit}>
      {alert || redirect}
      <FormGroup tag="fieldset">
        <legend>General</legend>
        <FormGroup row>
          <Col lg="6">
            <Label htmlFor="firstName">
              First Name
            </Label>
            <Field
              id="firstName"
              name="firstName"
              type="text"
              component={RenderInput}
              validate={[required, emptyOrMaxLength100]}
            />
            <FieldFeedback name="firstName" form={form} />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col lg="6">
            <Label htmlFor="lastName">
              Last Name
            </Label>
            <Field
              id="lastName"
              name="lastName"
              type="text"
              component={RenderInput}
              validate={[required, emptyOrMaxLength100]}
            />
            <FieldFeedback name="lastName" form={form} />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col lg="6">
            <Label htmlFor="email">
              Email
            </Label>
            <Field
              id="email"
              name="email"
              type="text"
              component={RenderInput}
              validate={[required, emptyOrEmail]}
            />
            <FieldFeedback name="email" form={form} />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col lg="6">
            <Label htmlFor="orgId">
              Organization
            </Label>
            <OrgSelectMenu name="orgId" validate={[required]} />
            <FieldFeedback name="orgId" form={form} />
          </Col>
        </FormGroup>
      </FormGroup>
      <FormGroup tag="fieldset">
        <legend>Permissions</legend>
        <FormGroup row check>
          <Col lg="5" className="ml-3">
            <Label check>
              <Field
                id="isAdmin"
                name="isAdmin"
                type="checkbox"
                component={RenderInput}
              />
              Is Admin
            </Label>
          </Col>
        </FormGroup>
      </FormGroup>
      <SubmitButton className="float-right" submitting={submitting}>
        Create
      </SubmitButton>
      <Button
        color="link"
        tag={Link}
        to="/admin/user"
      >
        Cancel
      </Button>
    </Form>
  );
};

CreateUserForm.defaultProps = {
  error: '',
};

export default CreateUserForm;



// WEBPACK FOOTER //
// ./js/components/pages/Admin/sections/Users/CreateUser/CreateUserForm/CreateUserForm.jsx